export const SearchBoxMagnifierIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='15'
            height='16'
            fill='none'
        >
            <path
                fill='#6E84A3'
                stroke='#6E84A3'
                strokeWidth='.7'
                d='M6.116 1.312a5.5 5.5 0 0 1 4.227 9.02l4.127 4.127a.5.5 0 0 1-.638.765l-.07-.058-4.126-4.127a5.5 5.5 0 1 1-3.52-9.727Zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z'
            />
        </svg>
    );
};
